module.exports = __webpack_public_path__ + "media/images/emblems/Chavornay-coat_of_arms-d71a1d39563e625a4742470efc090dbd.svg";